import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import { Grain, Thoranam } from '../components/Thoranam';
import { authMessage } from '../lib/authErrors';
import { useState } from 'react';

export function NoAccessPage() {
  const auth = useAuth();
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  if (auth.status === 'loading') {
    return (
      <div className="loader">
        <div>
          <div className="diya" />
          <p>Lighting the lamps…</p>
        </div>
      </div>
    );
  }
  if (auth.status === 'signedOut') return <Navigate to="/login" replace />;
  if (auth.status === 'ready') return <Navigate to="/" replace />;

  async function otherAccount() {
    setBusy(true);
    setErr(null);
    try {
      await auth.signInGoogle();
    } catch (e) {
      setErr(authMessage(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="shell">
      <div className="bg bg-login" />
      <Thoranam />
      <Grain />
      <main className="invite-wrap">
        <section className="invite" aria-labelledby="denied-title">
          <span className="coin c1" aria-hidden="true" />
          <span className="coin c2" aria-hidden="true" />
          <span className="coin c3" aria-hidden="true" />
          <span className="coin c4" aria-hidden="true" />
          <img
            className="invite-ganesha"
            src="/theme/ganesha-diya.jpg"
            alt="Ganesha with a brass diya"
          />
          <p className="kicker">The mandap is closed</p>
          <h1 id="denied-title">You do not have access</h1>
          <p className="sub">This Google account is not on the household list.</p>
          <p className="date-chip">{auth.user?.email ?? 'Unknown account'}</p>
          <hr className="gold-rule" />
          <p className="fine">
            Ask the family administrator to add this Gmail address under Household, then sign in
            again.
          </p>
          <div className="btn-row">
            <button className="btn gold" type="button" disabled={busy} onClick={() => void otherAccount()}>
              Try another Google account
            </button>
            <button className="btn ghost" type="button" disabled={busy} onClick={() => void auth.signOut()}>
              Sign out
            </button>
          </div>
          {err || auth.error ? <p className="msg">{err || auth.error}</p> : null}
        </section>
      </main>
    </div>
  );
}
